import Vue from "vue";
import Router from "vue-router";

//重写路由，避免出现这种错误：Navigating to current location ("/manage/user") is not allowed
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};
Vue.use(Router);
export default new Router({
  // mode: 'history',
  // hashbang: false, history: true,
  routes: [
    //设置路由
    {
      path: "",
      redirect: "/Login",
    },
    {
      path: "/QR",
      component: () => import("../views/QR.vue"),
      meta: {
        title: webTitleName() + " - " + schoolName(),
      },
    },
    {
      path: "/TestLogin",
      component: () => import("../views/TestLogin.vue"),
      meta: {
        title: webTitleName() + " - " + schoolName(),
      },
    },
    {
      // 用于钉钉通知中转站
      path: "/Notify",
      component: () => import("../views/Notify.vue"),
      meta: {
        title: webTitleName() + " - " + schoolName(),
      },
    },
    {
      path: "/QRClass",
      component: () => import("../views/QRClass.vue"),
      meta: {
        title: webTitleName() + " - " + schoolName(),
      },
    },
    {
      path: "/DingDing",
      component: () => import("../views/DingDing.vue"),
      meta: {
        title: "钉钉授权登录 - " + webTitleName() + " - " + schoolName(),
      },
    },
    {
      path: "/Logout",
      component: () => import("../views/Logout.vue"),
      meta: {
        title: "退出登录 - " + webTitleName() + " - " + schoolName(),
      },
    },
    {
      path: "/Admin/BigScreen/:Id",
      component: () => import("../views/Admin/Statistics/BigScreen.vue"),
      meta: {
        title: "驾驶舱数据展示 - " + webTitleName() + " - " + schoolName(),
      },
    },
    {
      path: "/Cockpit",
      component: () => import("../views/Cockpit.vue"),
      meta: {
        title: "驾驶舱数据展示 - " + webTitleName() + " - " + schoolName(),
      },
    },
    {
      path: "/Admin/Home/Default",
      component: () => import("../views/Admin/Home/Default.vue"),
      meta: {
        title: webTitleName() + " - " + schoolName(),
      },
    },
    /*
     ******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************
     ******** 管理端 ******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************
     */
    {
      path: "/Login",
      component: () => import("../views/Login.vue"),
      meta: {
        title: "登录 - " + webTitleName() + " - " + schoolName(),
      },
    },
    {
      path: "/Admin/Default",
      component: () => import("../views/Admin/Default.vue"),
      meta: {
        title: webTitleName() + " - " + schoolName(),
      },
      redirect: "/Admin/Preparations/Index", // 默认起始页
      children: [
        {
          path: "/Admin/Statistics/BigScreen",
          component: () => import("../views/Admin/Statistics/BigScreen.vue"),
          meta: {
            title: "全校大数据 - " + webTitleName() + " - " + schoolName(),
          },
        },
        //**********> Home <*************** 首页
        {
          path: "/Admin/Home/Index",
          component: () => import("../views/Admin/Home/Index.vue"),
          meta: {
            title: webTitleName() + " - " + schoolName(),
          },
        },
        {
          path: "/Admin/Home/Home",
          component: () => import("../views/Admin/Home/Home.vue"),
          meta: {
            title: schoolName(),
          },
        },
        {
          path: "/redirect",
          component: () => import("../components/redirect.vue"),
        },
        /******************************************************************************************
          钉钉推送
        *******************************************************************************************/
        {
          path: "/Admin/System/Deliver",
          component: () => import("../views/Admin/System/Deliver.vue"),
          meta: {
            title: "钉钉推送 - " + schoolName(),
          },
        },
        /******************************************************************************************
          学生加分管理
        *******************************************************************************************/
        {
          path: "/Admin/User/Ai",
          component: () => import("../views/Admin/User/Ai.vue"),
          meta: {
            title: "AI评语设置 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Adviser/CommentType/Index",
          component: () =>
            import("../views/Admin/Adviser/CommentType/Index.vue"),
          meta: {
            title: "短语级别 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Adviser/CommentPhrase/Index",
          component: () =>
            import("../views/Admin/Adviser/CommentPhrase/Index.vue"),
          meta: {
            title: "短语管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Adviser/StudentComment/AI",
          component: () =>
            import("../views/Admin/Adviser/StudentComment/Ai.vue"),
          meta: {
            title: "AI评语 - " + schoolName(),
          },
        },

        /******************************************************************************************
          学生加分管理
        *******************************************************************************************/
        {
          path: "/Admin/ExtraPoints/Index",
          component: () => import("../views/Admin/ExtraPoints/Index.vue"),
          meta: {
            title: "学生加分管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Adviser/Morality/Test/:type",
          component: () => import("../views/Admin/Adviser/Morality/Test.vue"),
          meta: {
            title: "测试页面 - " + schoolName(),
          },
        },

        /******************************************************************************************
          统计
        *******************************************************************************************/
        {
          // 行为规范
          path: "/Admin/Statistics/Behavior",
          component: () => import("../views/Admin/Statistics/Behavior.vue"),
          meta: {
            title: "行为规范统计 - " + schoolName(),
          },
        },
        {
          //德育分
          path: "/Admin/Statistics/Moral",
          component: () => import("../views/Admin/Statistics/Moral.vue"),
          meta: {
            title: "德育分统计 - " + schoolName(),
          },
        },
        {
          //学生奖励
          path: "/Admin/Statistics/Award",
          component: () => import("../views/Admin/Statistics/Award.vue"),
          meta: {
            title: "学生奖励统计 - " + schoolName(),
          },
        },
        {
          //核养溯源分析
          path: "/Admin/Statistics/Traceability",
          component: () => import("../views/Admin/Statistics/Traceability.vue"),
          meta: {
            title: "评价类型溯源 - " + schoolName(),
          },
        },
        {
          //请假统计
          path: "/Admin/Statistics/Leave",
          component: () => import("../views/Admin/Statistics/Leave.vue"),
          meta: {
            title: "学生请假统计 - " + schoolName(),
          },
        },
        {
          //教师工作量统计
          path: "/Admin/Statistics/Workload",
          component: () => import("../views/Admin/Statistics/Workload.vue"),
          meta: {
            title: "统计管理 - " + schoolName(),
          },
        },
        /******************************************************************************************
          寝室考勤
        *******************************************************************************************/
        {
          path: "/Admin/DormitoryAttn/Index",
          component: () => import("../views/Admin/DormitoryAttn/Index.vue"),
          meta: {
            title: "寝室考勤 - " + schoolName(),
          },
        },
        {
          path: "/Admin/DormPunchIn/Index",
          component: () => import("../views/Admin/DormPunchIn/Index.vue"),
          meta: {
            title: "考勤管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/DormPunchIn/Member",
          component: () => import("../views/Admin/DormPunchIn/Member.vue"),
          meta: {
            title: "考勤管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/DormPunchIn/SignInRate",
          component: () => import("../views/Admin/DormPunchIn/SignInRate.vue"),
          meta: {
            title: "考勤管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Statistics/SignInRate",
          component: () => import("../views/Admin/Statistics/SignInRate.vue"),
          meta: {
            title: "统计分析 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Statistics/PunchInDetails",
          component: () =>
            import("../views/Admin/Statistics/PunchInDetails.vue"),
          meta: {
            title: "统计分析 - " + schoolName(),
          },
        },
        {
          path: "/Admin/DormPunchIn/Details/:Id",
          component: () => import("../views/Admin/DormPunchIn/Details.vue"),
          meta: {
            title: "寝室考勤 - " + schoolName(),
          },
        },
        {
          path: "/Admin/DormPunchIn/Floor/:Id",
          component: () => import("../views/Admin/DormPunchIn/Floor.vue"),
          meta: {
            title: "寝室考勤 - " + schoolName(),
          },
        },
        {
          // 未打卡
          path: "/Admin/DormPunchIn/NotClockedIn",
          component: () =>
            import("../views/Admin/DormPunchIn/NotClockedIn.vue"),
          meta: {
            title: "考勤管理 - " + schoolName(),
          },
        },
        /******************************************************************************************
          请假管理
        *******************************************************************************************/
        {
          path: "/Admin/LeaveMGT/Index",
          component: () => import("../views/Admin/LeaveMGT/Index.vue"),
          meta: {
            title: "学生请假管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/LeaveMGT/Default/:Id",
          component: () => import("../views/Admin/LeaveMGT/Default.vue"),
          meta: {
            title: "学生请假管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/LeaveMGT/Create",
          component: () => import("../views/Admin/LeaveMGT/Update.vue"),
          meta: {
            title: "代学生请假 - " + schoolName(),
          },
        },
        {
          path: "/Admin/LeaveMGT/Dormitory",
          component: () => import("../views/Admin/LeaveMGT/Dormitory.vue"),
          meta: {
            title: "学生请假管理 - " + webTitleName() + " - " + schoolName(),
          },
        },
        /******************************************************************************************
          门卫安保
        *******************************************************************************************/
        {
          path: "/Admin/GuardSecurity/Index",
          name: "Admin_GuardSecurity_Index",
          component: () => import("../views/Admin/GuardSecurity/Index.vue"),
          meta: {
            title: "门卫安保 - " + webTitleName() + " - " + schoolName(),
          },
        },
        {
          path: "/Admin/GuardSecurity/Details/:Id",
          name: "Admin_GuardSecurity_Details",
          component: () => import("../views/Admin/GuardSecurity/Details.vue"),
          meta: {
            title: "学生请假管理 - " + webTitleName() + " - " + schoolName(),
          },
        },
        /******************************************************************************************
          班主任考核
        *******************************************************************************************/
        {
          path: "/Admin/Assessment/Moon/Index",
          component: () => import("../views/Admin/Assessment/Moon/Index.vue"),
          meta: {
            title: "班主任考核 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Assessment/Moon/Details/:Id",
          component: () => import("../views/Admin/Assessment/Moon/Details.vue"),
          meta: {
            title: "班主任考核 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Assessment/Semester",
          component: () => import("../views/Admin/Assessment/Semester.vue"),
          meta: {
            title: "班主任考核 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Assessment/Semester/Index",
          component: () =>
            import("../views/Admin/Assessment/Semester/Index.vue"),
          meta: {
            title: "班主任考核 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Assessment/Semester/Details/:Id",
          component: () =>
            import("../views/Admin/Assessment/Semester/Details.vue"),
          meta: {
            title: "班主任考核 - " + schoolName(),
          },
        },
        //学年考核
        {
          path: "/Admin/Assessment/AcademicYear/Index",
          component: () =>
            import("../views/Admin/Assessment/AcademicYear/Index.vue"),
          meta: {
            title: "学年考核 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Assessment/AcademicYear/Details/:Id",
          component: () =>
            import("../views/Admin/Assessment/AcademicYear/Details.vue"),
          meta: {
            title: "学年考核 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Assessment/AcademicYear/create",
          component: () =>
            import("../views/Admin/Assessment/AcademicYear/Update.vue"),
          meta: {
            title: "学年考核 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Assessment/AcademicYear/Edit/:id",
          component: () =>
            import("../views/Admin/Assessment/AcademicYear/Update.vue"),
          meta: {
            title: "学年考核 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Assessment/Customize",
          component: () => import("../views/Admin/Assessment/Customize.vue"),
          meta: {
            title: "学年考核 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Assessment/PlusMinus",
          component: () => import("../views/Admin/Assessment/PlusMinus.vue"),
          meta: {
            title: "学年考核 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Assessment/Routine",
          component: () => import("../views/Admin/Assessment/Routine.vue"),
          meta: {
            title: "学年考核 - " + schoolName(),
          },
        },
        /*********************************************************************************
            安全考核奖
        **********************************************************************************/
        {
          path: "/Admin/SafetyAward/Index",
          component: () => import("../views/Admin/SafetyAward/Index.vue"),
          meta: {
            title: "安全考核奖 - " + schoolName(),
          },
        },
        /**
         * 班主任考核管理-------------------------------------------------------------------------------------------------------------
         */
        //自定义考核项目
        //学期考核加减分
        {
          path: "/Admin/Assessment/Semester/PlusMinus/Index",
          component: () =>
            import("../views/Admin/Assessment/Semester/PlusMinus/Index.vue"),
          meta: {
            title: "学期考核加减分 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Assessment/Semester/PlusMinus/Create",
          component: () =>
            import("../views/Admin/Assessment/Semester/PlusMinus/Update.vue"),
          meta: {
            title: "学期考核加减分 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Assessment/Semester/PlusMinus/Edit/:Id",
          component: () =>
            import("../views/Admin/Assessment/Semester/PlusMinus/Update.vue"),
          meta: {
            title: "学期考核加减分 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Assessment/Semester/PlusMinus/Details/:Id",
          component: () =>
            import("../views/Admin/Assessment/Semester/PlusMinus/Details.vue"),
          meta: {
            title: "学期考核加减分 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Assessment/ReView/Index",
          component: () => import("../views/Admin/Assessment/ReView.vue"),
          meta: {
            title: "学期考核加减分 - " + schoolName(),
          },
        },
        // 月考核常规项
        {
          path: "/Admin/Assessment/Routine/Index",
          component: () =>
            import("../views/Admin/Assessment/Routine/Index.vue"),
          meta: {
            title: "月考核常规项 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Assessment/Routine/Create",
          component: () =>
            import("../views/Admin/Assessment/Routine/Update.vue"),
          meta: {
            title: "月考核常规项 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Assessment/Routine/Edit/:Id",
          component: () =>
            import("../views/Admin/Assessment/Routine/Update.vue"),
          meta: {
            title: "月考核常规项 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Assessment/Routine/Details/:Id",
          component: () =>
            import("../views/Admin/Assessment/Routine/Details.vue"),
          meta: {
            title: "月考核常规项 - " + schoolName(),
          },
        },
        // 自定义项目
        {
          path: "/Admin/Assessment/Customize/Index",
          component: () =>
            import("../views/Admin/Assessment/Customize/Index.vue"),
          meta: {
            title: "月考核常规项 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Assessment/Customize/Details/:Id",
          component: () =>
            import("../views/Admin/Assessment/Customize/Details.vue"),
          meta: {
            title: "月考核常规项 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Assessment/Customize/Create",
          component: () =>
            import("../views/Admin/Assessment/Customize/Update.vue"),
          meta: {
            title: "月考核常规项 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Assessment/Customize/Edit/:Id",
          component: () =>
            import("../views/Admin/Assessment/Customize/Update.vue"),
          meta: {
            title: "月考核常规项 - " + schoolName(),
          },
        },
        // 月考核加减分项
        {
          path: "/Admin/Assessment/PlusMinus/Index",
          component: () =>
            import("../views/Admin/Assessment/PlusMinus/Index.vue"),
          meta: {
            title: "月考核加减分项 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Assessment/PlusMinus/Details/:Id",
          component: () =>
            import("../views/Admin/Assessment/PlusMinus/Details.vue"),
          meta: {
            title: "月考核加减分项 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Assessment/PlusMinus/Create",
          component: () =>
            import("../views/Admin/Assessment/PlusMinus/Update.vue"),
          meta: {
            title: "月考核加减分项 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Assessment/PlusMinus/Edit/:Id",
          component: () =>
            import("../views/Admin/Assessment/PlusMinus/Update.vue"),
          meta: {
            title: "月考核加减分项 - " + schoolName(),
          },
        },
        /*********************************************************************************
            奖学金管理
        **********************************************************************************/
        {
          path: "/Admin/ScholarshipMGT/Batch/Index",
          component: () =>
            import("../views/Admin/ScholarshipMGT/Batch/Index.vue"),
          meta: {
            title: "奖学金管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/ScholarshipMGT/Batch/Create",
          component: () =>
            import("../views/Admin/ScholarshipMGT/Batch/Update.vue"),
          meta: {
            title: "奖学金管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/ScholarshipMGT/Batch/Edit/:Id",
          component: () =>
            import("../views/Admin/ScholarshipMGT/Batch/Update.vue"),
          meta: {
            title: "奖学金管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/ScholarshipMGT/Batch/Details/:Id",
          component: () =>
            import("../views/Admin/ScholarshipMGT/Batch/Details.vue"),
          meta: {
            title: "奖学金管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/ScholarshipMGT/Roster/Index/:Id",
          component: () =>
            import("../views/Admin/ScholarshipMGT/Roster/Index.vue"),
          meta: {
            title: "奖学金管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/ScholarshipMGT/Roster/Details/:Id",
          component: () =>
            import("../views/Admin/ScholarshipMGT/Roster/Details.vue"),
          meta: {
            title: "奖学金管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/ScholarshipMGT/Info/Index/:Id",
          component: () =>
            import("../views/Admin/ScholarshipMGT/Info/Index.vue"),
          meta: {
            title: "奖学金管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/ScholarshipMGT/Info/Details/:Id",
          component: () =>
            import("../views/Admin/ScholarshipMGT/Info/Details.vue"),
          meta: {
            title: "奖学金管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/ScholarshipMGT/Audit/Index",
          component: () =>
            import("../views/Admin/ScholarshipMGT/Audit/Index.vue"),
          meta: {
            title: "奖学金管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/ScholarshipMGT/Audit/Details/:Id",
          component: () =>
            import("../views/Admin/ScholarshipMGT/Audit/Details.vue"),
          meta: {
            title: "奖学金管理 - " + schoolName(),
          },
        },
        /*********************************************************************************
            学生会管理
        **********************************************************************************/
        {
          path: "/Admin/StudentUnion/Index",
          component: () => import("../views/Admin/StudentUnion/Index.vue"),
          meta: {
            title: "学生会管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/StudentUnion/Details/:Id",
          component: () => import("../views/Admin/StudentUnion/Details.vue"),
          meta: {
            title: "学生会管理 - " + schoolName(),
          },
        },
        /*********************************************************************************
           德育分
        **********************************************************************************/
        {
          path: "/Admin/MoralEducation/Index",
          component: () => import("../views/Admin/MoralEducation/Index.vue"),
          meta: {
            title: "班级德育分 - " + schoolName(),
          },
        },
        {
          path: "/Admin/MoralEducation/Details/:Id",
          component: () => import("../views/Admin/MoralEducation/Details.vue"),
          meta: {
            title: "班级德育分 - " + schoolName(),
          },
        },
        {
          path: "/Admin/MoralEducation/Create",
          component: () => import("../views/Admin/MoralEducation/Update.vue"),
          meta: {
            title: "班级德育分 - " + schoolName(),
          },
        },
        {
          path: "/Admin/MoralEducation/Edit/:Id",
          component: () => import("../views/Admin/MoralEducation/Update.vue"),
          meta: {
            title: "班级德育分 - " + schoolName(),
          },
        },
        {
          path: "/Admin/MoralEducation/Evaluation",
          component: () =>
            import("../views/Admin/MoralEducation/Evaluation.vue"),
          meta: {
            title: "班级德育分 - " + schoolName(),
          },
        },
        {
          // 扣分原因
          path: "/Admin/MoralEducationReason/Index",
          component: () =>
            import("../views/Admin/MoralEducationReason/Index.vue"),
          meta: {
            title: "班级德育分配置 - " + schoolName(),
          },
        },
        {
          // 扣分原因
          path: "/Admin/MoralEducationReason/Create",
          component: () =>
            import("../views/Admin/MoralEducationReason/Reason.vue"),
          meta: {
            title: "班级德育分配置 - " + schoolName(),
          },
        },
        {
          // 扣分原因
          path: "/Admin/MoralEducationReason/Update/:Id",
          component: () =>
            import("../views/Admin/MoralEducationReason/Reason.vue"),
          meta: {
            title: "班级德育分配置 - " + schoolName(),
          },
        },
        /*********************************************************************************
            总评配置
        **********************************************************************************/
        {
          //列表
          path: "/Admin/EvaluationConfig/Index",
          component: () => import("../views/Admin/EvaluationConfig/Index.vue"),
          meta: {
            title: "学生总评配置 - " + schoolName(),
          },
        },
        {
          //新增
          path: "/Admin/EvaluationConfig/Create",
          component: () => import("../views/Admin/EvaluationConfig/Update.vue"),
          meta: {
            title: "学生总评配置 - " + schoolName(),
          },
        },
        {
          //编辑
          path: "/Admin/EvaluationConfig/Update/:id",
          component: () => import("../views/Admin/EvaluationConfig/Update.vue"),
          meta: {
            title: "学生总评配置 - " + schoolName(),
          },
        },
        /*********************************************************************************
            综合之星配置
        **********************************************************************************/
        {
          //列表
          path: "/Admin/LiteracyStarConfig/Index",
          component: () =>
            import("../views/Admin/LiteracyStarConfig/Index.vue"),
          meta: {
            title: "成长之星配置 - " + schoolName(),
          },
        },
        {
          //列表
          path: "/Admin/LiteracyStarConfig/Details/:id",
          component: () =>
            import("../views/Admin/LiteracyStarConfig/Details.vue"),
          meta: {
            title: "成长之星配置 - " + schoolName(),
          },
        },
        {
          //新增
          path: "/Admin/LiteracyStarConfig/Create",
          component: () =>
            import("../views/Admin/LiteracyStarConfig/Update.vue"),
          meta: {
            title: "成长之星配置 - " + schoolName(),
          },
        },
        {
          //编辑
          path: "/Admin/LiteracyStarConfig/Update/:id",
          component: () =>
            import("../views/Admin/LiteracyStarConfig/Update.vue"),
          meta: {
            title: "成长之星配置 - " + schoolName(),
          },
        },
        /*********************************************************************************
            综合之星
        **********************************************************************************/
        {
          //列表
          path: "/Admin/LiteracyStar/Index",
          component: () => import("../views/Admin/LiteracyStar/Index.vue"),
          meta: {
            title: "成长之星计算 - " + schoolName(),
          },
        },
        {
          //评比
          path: "/Admin/LiteracyStar/Default",
          component: () => import("../views/Admin/LiteracyStar/Default.vue"),
          meta: {
            title: "成长之星计算 - " + schoolName(),
          },
        },
        /*********************************************************************************
            准备工作 Preparations
        **********************************************************************************/
        {
          //列表
          path: "/Admin/Preparations/Index",
          component: () => import("../views/Admin/Preparations/Index.vue"),
          meta: {
            title: "工作台 - " + schoolName(),
          },
        },
        {
          //列表
          path: "/Admin/Academictransform/Index",
          component: () => import("../views/Admin/Academictransform/Index.vue"),
          meta: {
            title: "考查课分数转换 - " + schoolName(),
          },
        },
        {
          //列表
          path: "/Admin/MyWorkload/Index",
          component: () => import("../views/Admin/MyWorkload/Index.vue"),
          meta: {
            title: "我的工作量统计 - " + schoolName(),
          },
        },
        /*********************************************************************************
            社员职务
        **********************************************************************************/
        {
          //列表
          path: "/Admin/Club/ClubPosition/Index",
          component: () => import("../views/Admin/Club/ClubPosition/Index.vue"),
          meta: {
            title: "社员职务 - " + schoolName(),
          },
        },
        /*********************************************************************************
            社团信息
        **********************************************************************************/
        {
          //列表
          path: "/Admin/Club/ClubMGMT/Index",
          component: () => import("../views/Admin/Club/ClubMGMT/Index.vue"),
          meta: {
            title: "社团信息 - " + schoolName(),
          },
        },
        {
          //新增
          path: "/Admin/Club/ClubMGMT/Create",
          component: () => import("../views/Admin/Club/ClubMGMT/Update.vue"),
          meta: {
            title: "社团信息 - " + schoolName(),
          },
        },
        {
          //编辑
          path: "/Admin/Club/ClubMGMT/Edit/:Id",
          component: () => import("../views/Admin/Club/ClubMGMT/Update.vue"),
          meta: {
            title: "社团信息 - " + schoolName(),
          },
        },
        {
          //详情
          path: "/Admin/Club/ClubMGMT/Details/:Id",
          component: () => import("../views/Admin/Club/ClubMGMT/Details.vue"),
          meta: {
            title: "社团信息 - " + schoolName(),
          },
        },
        /*********************************************************************************
            社团活动
        **********************************************************************************/
        {
          //列表
          path: "/Admin/Club/ClubActivities/Index",
          component: () =>
            import("../views/Admin/Club/ClubActivities/Index.vue"),
          meta: {
            title: "社团活动 - " + schoolName(),
          },
        },
        {
          //列表
          path: "/Admin/Club/MyClubActivities/Index/:type",
          component: () =>
            import("../views/Admin/Club/ClubActivities/Index.vue"),
          meta: {
            title: "社团活动 - " + schoolName(),
          },
        },
        {
          //列表
          path: "/Admin/Club/ClubActivities/Details/:Id",
          component: () =>
            import("../views/Admin/Club/ClubActivities/Details.vue"),
          meta: {
            title: "社团活动 - " + schoolName(),
          },
        },
        /*********************************************************************************
            学生基础信息 Student
        **********************************************************************************/
        {
          //列表
          path: "/Admin/Student/Index",
          component: () => import("../views/Admin/Student/Index.vue"),
          meta: {
            title: "学生基础信息 - " + schoolName(),
          },
        },
        {
          //详情
          path: "/Admin/Student/Detail/:id",
          component: () => import("../views/Admin/Student/Detail.vue"),
          meta: {
            title: "学生基础信息 - " + schoolName(),
          },
        },
        {
          // 编辑
          path: "/Admin/Student/Edit/:id",
          component: () => import("../views/Admin/Student/Edit.vue"),
          meta: {
            title: "学生基础信息 - " + schoolName(),
          },
        },
        {
          // 新增
          path: "/Admin/Student/Create",
          component: () => import("../views/Admin/Student/Create.vue"),
          meta: {
            title: "学生基础信息 - " + schoolName(),
          },
        },
        /*********************************************************************************
            综合评价 Growth
        **********************************************************************************/
        {
          //列表
          path: "/Admin/Growth/Index",
          component: () => import("../views/Admin/Growth/Index.vue"),
          meta: {
            title: "综合评价 - " + schoolName(),
          },
        },
        {
          // 详情
          path: "/Admin/Growth/Details/:id",
          component: () => import("../views/Admin/Growth/Details.vue"),
          meta: {
            title: "综合评价 - " + schoolName(),
          },
        },
        /*********************************************************************************
            班级评价 GrowthClass
        **********************************************************************************/
        {
          //列表
          path: "/Admin/GrowthClass/Index",
          component: () => import("../views/Admin/GrowthClass/Index.vue"),
          meta: {
            title: "综合评价 - " + schoolName(),
          },
        },
        {
          // 详情
          path: "/Admin/GrowthClass/Details/:id",
          component: () => import("../views/Admin/GrowthClass/Details.vue"),
          meta: {
            title: "综合评价 - " + schoolName(),
          },
        },
        /*********************************************************************************
            综合课堂 LiteracyCourse
        **********************************************************************************/
        {
          //列表
          path: "/Admin/LiteracyCourse/Index",
          component: () => import("../views/Admin/LiteracyCourse/Index.vue"),
          meta: {
            title: "综合课堂 - " + schoolName(),
          },
        },
        {
          // 新增
          path: "/Admin/LiteracyCourse/Create",
          component: () => import("../views/Admin/LiteracyCourse/Operat.vue"),
          meta: {
            title: "综合课堂 - " + schoolName(),
          },
        },
        {
          // 编辑
          path: "/Admin/LiteracyCourse/Edit/:id",
          component: () => import("../views/Admin/LiteracyCourse/Operat.vue"),
          meta: {
            title: "综合课堂 - " + schoolName(),
          },
        },
        {
          // 详情
          path: "/Admin/LiteracyCourse/Details/:id",
          component: () => import("../views/Admin/LiteracyCourse/Details.vue"),
          meta: {
            title: "综合课堂 - " + schoolName(),
          },
        },
        /*********************************************************************************
            综合课堂类型 LiteracyCourseType
        **********************************************************************************/
        {
          //列表
          path: "/Admin/LiteracyCourseType/Index",
          component: () =>
            import("../views/Admin/LiteracyCourseType/Index.vue"),
          meta: {
            title: "综合课堂类型 - " + schoolName(),
          },
        },
        {
          // 新增
          path: "/Admin/LiteracyCourseType/Create",
          component: () =>
            import("../views/Admin/LiteracyCourseType/Operat.vue"),
          meta: {
            title: "综合课堂类型 - " + schoolName(),
          },
        },
        {
          // 编辑
          path: "/Admin/LiteracyCourseType/Edit/:id",
          component: () =>
            import("../views/Admin/LiteracyCourseType/Operat.vue"),
          meta: {
            title: "综合课堂类型 - " + schoolName(),
          },
        },
        {
          // 详情
          path: "/Admin/LiteracyCourseType/Details/:id",
          component: () =>
            import("../views/Admin/LiteracyCourseType/Details.vue"),
          meta: {
            title: "综合课堂类型 - " + schoolName(),
          },
        },

        /*********************************************************************************
            成长档案
        **********************************************************************************/
        {
          //列表
          path: "/Admin/GrowthArchives/Index",
          component: () => import("../views/Admin/GrowthArchives/Index.vue"),
          meta: {
            title: "成长档案 - " + schoolName(),
          },
        },
        {
          //详情
          path: "/Admin/GrowthArchives/Details/:id",
          component: () => import("../views/Admin/GrowthArchives/Details.vue"),
          meta: {
            title: "成长档案 - " + schoolName(),
          },
        },
        //班主任手册检查
        //班主任手册检查
        {
          //列表
          path: "/Admin/Adviser/ManualInspection/Index",
          component: () =>
            import("../views/Admin/Adviser/ManualInspection/Index.vue"),
          meta: {
            title: "班主任手册 - " + schoolName(),
          },
        },
        {
          //列表
          path: "/Admin/Adviser/ManualInspection/studentPriceDetail/:Id",
          component: () =>
            import(
              "../views/Admin/Adviser/ManualInspection/studentPriceDetail.vue"
            ),
          meta: {
            title: "班主任手册 - " + schoolName(),
          },
        },
        {
          //列表
          path: "/Admin/Adviser/ManualInspection/Details/:Id",
          component: () =>
            import("../views/Admin/Adviser/ManualInspection/Details.vue"),
          meta: {
            title: "班主任手册 - " + schoolName(),
          },
        },
        //学期工作计划
        /**********************************************************************************/
        {
          //列表
          path: "/Admin/Adviser/WorkPlan/Index",
          component: () => import("../views/Admin/Adviser/WorkPlan/Index.vue"),
          meta: {
            title: "学期工作计划 - " + schoolName(),
          },
        },
        {
          //新增
          path: "/Admin/Adviser/WorkPlan/Create",
          component: () => import("../views/Admin/Adviser/WorkPlan/Create.vue"),
          meta: {
            title: "学期工作计划 - " + schoolName(),
          },
        },
        {
          //编辑
          path: "/Admin/Adviser/WorkPlan/Edit/:Id",
          component: () => import("../views/Admin/Adviser/WorkPlan/Create.vue"),
          meta: {
            title: "学期工作计划 - " + schoolName(),
          },
        },
        /*********************************************************************************
        /*********************************************************************************
            班干部职位管理
        **********************************************************************************/
        {
          //列表
          path: "/Admin/Adviser/ClassPosition/Index",
          component: () =>
            import("../views/Admin/Adviser/ClassPosition/Index.vue"),
          meta: {
            title: "班干部职位管理 - " + schoolName(),
          },
        },
        /*********************************************************************************
            学期活动计划
        **********************************************************************************/
        {
          //列表
          path: "/Admin/Adviser/ActivityPlan/Index",
          component: () =>
            import("../views/Admin/Adviser/ActivityPlan/Index.vue"),
          meta: {
            title: "班主任手册 - " + schoolName(),
          },
        },
        {
          //新增
          path: "/Admin/Adviser/ActivityPlan/Create",
          component: () =>
            import("../views/Admin/Adviser/ActivityPlan/Create.vue"),
          meta: {
            title: "班主任手册 - " + schoolName(),
          },
        },
        {
          //编辑
          path: "/Admin/Adviser/ActivityPlan/Edit/:Id",
          component: () =>
            import("../views/Admin/Adviser/ActivityPlan/Create.vue"),
          meta: {
            title: "班主任手册 - " + schoolName(),
          },
        },
        /*********************************************************************************
            班级备忘录
        **********************************************************************************/
        {
          //列表
          path: "/Admin/Adviser/ClassWorkMemo/Index",
          component: () =>
            import("../views/Admin/Adviser/ClassWorkMemo/Index.vue"),
          meta: {
            title: "班级备忘录 - " + schoolName(),
          },
        },
        {
          //新增
          path: "/Admin/Adviser/ClassWorkMemo/Create",
          component: () =>
            import("../views/Admin/Adviser/ClassWorkMemo/Create.vue"),
          meta: {
            title: "班级备忘录 - " + schoolName(),
          },
        },
        {
          //编辑
          path: "/Admin/Adviser/ClassWorkMemo/Edit/:Id",
          component: () =>
            import("../views/Admin/Adviser/ClassWorkMemo/Create.vue"),
          meta: {
            title: "班级备忘录 - " + schoolName(),
          },
        },
        /*********************************************************************************
            主题班会
        **********************************************************************************/
        {
          //列表
          path: "/Admin/Adviser/ClassMeeting/Index",
          component: () =>
            import("../views/Admin/Adviser/ClassMeeting/Index.vue"),
          meta: {
            title: "主题班会 - " + schoolName(),
          },
        },
        {
          //新增
          path: "/Admin/Adviser/ClassMeeting/Create",
          component: () =>
            import("../views/Admin/Adviser/ClassMeeting/Create.vue"),
          meta: {
            title: "主题班会 - " + schoolName(),
          },
        },
        {
          //编辑
          path: "/Admin/Adviser/ClassMeeting/Edit/:Id",
          component: () =>
            import("../views/Admin/Adviser/ClassMeeting/Create.vue"),
          meta: {
            title: "主题班会 - " + schoolName(),
          },
        },
        {
          //查看
          path: "/Admin/Adviser/ClassMeeting/Details/:Id",
          component: () =>
            import("../views/Admin/Adviser/ClassMeeting/Details.vue"),
          meta: {
            title: "主题班会 - " + schoolName(),
          },
        },
        /*********************************************************************************
            家长会
        **********************************************************************************/
        {
          //列表
          path: "/Admin/Adviser/ContactRecord/Index",
          component: () =>
            import("../views/Admin/Adviser/ContactRecord/Index.vue"),
          meta: {
            title: "家校联系 - " + schoolName(),
          },
        },
        {
          //新增
          path: "/Admin/Adviser/ContactRecord/Create",
          component: () =>
            import("../views/Admin/Adviser/ContactRecord/Create.vue"),
          meta: {
            title: "家校联系 - " + schoolName(),
          },
        },
        {
          //编辑
          path: "/Admin/Adviser/ContactRecord/Edit/:Id",
          component: () =>
            import("../views/Admin/Adviser/ContactRecord/Create.vue"),
          meta: {
            title: "家校联系 - " + schoolName(),
          },
        },
        {
          //查看
          path: "/Admin/Adviser/ContactRecord/Details/:Id",
          component: () =>
            import("../views/Admin/Adviser/ContactRecord/Details.vue"),
          meta: {
            title: "家校联系 - " + schoolName(),
          },
        },
        /*********************************************************************************
            家校活动记录
        **********************************************************************************/
        {
          //列表
          path: "/Admin/Adviser/ParentActivityRecord/Index",
          component: () =>
            import("../views/Admin/Adviser/ParentActivityRecord/Index.vue"),
          meta: {
            title: "家校活动记录 - " + schoolName(),
          },
        },
        {
          //新增
          path: "/Admin/Adviser/ParentActivityRecord/Create",
          component: () =>
            import("../views/Admin/Adviser/ParentActivityRecord/Create.vue"),
          meta: {
            title: "家校活动记录 - " + schoolName(),
          },
        },
        {
          //编辑
          path: "/Admin/Adviser/ParentActivityRecord/Edit/:Id",
          component: () =>
            import("../views/Admin/Adviser/ParentActivityRecord/Create.vue"),
          meta: {
            title: "家校活动记录 - " + schoolName(),
          },
        },
        {
          //查看
          path: "/Admin/Adviser/ParentActivityRecord/Details/:Id",
          component: () =>
            import("../views/Admin/Adviser/ParentActivityRecord/Details.vue"),
          meta: {
            title: "家校活动记录 - " + schoolName(),
          },
        },
        /*********************************************************************************
            学期工作总结
        **********************************************************************************/
        {
          //列表
          path: "/Admin/Adviser/WorkSummary/Index",
          component: () =>
            import("../views/Admin/Adviser/WorkSummary/Index.vue"),
          meta: {
            title: "学期工作总结 - " + schoolName(),
          },
        },
        {
          //新增
          path: "/Admin/Adviser/WorkSummary/Create",
          component: () =>
            import("../views/Admin/Adviser/WorkSummary/Create.vue"),
          meta: {
            title: "学期工作总结 - " + schoolName(),
          },
        },
        {
          //编辑
          path: "/Admin/Adviser/WorkSummary/Edit/:Id",
          component: () =>
            import("../views/Admin/Adviser/WorkSummary/Create.vue"),
          meta: {
            title: "学期工作总结 - " + schoolName(),
          },
        },
        /*********************************************************************************
            双优生分析
        **********************************************************************************/
        {
          //列表
          path: "/Admin/Adviser/DoubleEugenics/Index",
          component: () =>
            import("../views/Admin/Adviser/DoubleEugenics/Index.vue"),
          meta: {
            title: "双优生分析 - " + schoolName(),
          },
        },
        {
          //新增
          path: "/Admin/Adviser/DoubleEugenics/Create",
          component: () =>
            import("../views/Admin/Adviser/DoubleEugenics/Create.vue"),
          meta: {
            title: "双优生分析 - " + schoolName(),
          },
        },
        {
          //编辑
          path: "/Admin/Adviser/DoubleEugenics/Edit/:Id",
          component: () =>
            import("../views/Admin/Adviser/DoubleEugenics/Create.vue"),
          meta: {
            title: "双优生分析 - " + schoolName(),
          },
        },
        {
          //查看
          path: "/Admin/Adviser/DoubleEugenics/Details/:Id",
          component: () =>
            import("../views/Admin/Adviser/DoubleEugenics/Details.vue"),
          meta: {
            title: "双优生分析 - " + schoolName(),
          },
        },
        /*********************************************************************************
            行为偏常辅导
        **********************************************************************************/
        {
          //列表
          path: "/Admin/Adviser/AbnormalBehavior/Index",
          component: () =>
            import("../views/Admin/Adviser/AbnormalBehavior/Index.vue"),
          meta: {
            title: "行为偏常辅导 - " + schoolName(),
          },
        },
        {
          //新增
          path: "/Admin/Adviser/AbnormalBehavior/Create",
          component: () =>
            import("../views/Admin/Adviser/AbnormalBehavior/Create.vue"),
          meta: {
            title: "行为偏常辅导 - " + schoolName(),
          },
        },
        {
          //编辑
          path: "/Admin/Adviser/AbnormalBehavior/Edit/:Id",
          component: () =>
            import("../views/Admin/Adviser/AbnormalBehavior/Create.vue"),
          meta: {
            title: "行为偏常辅导 - " + schoolName(),
          },
        },
        {
          //查看
          path: "/Admin/Adviser/AbnormalBehavior/Details/:Id",
          component: () =>
            import("../views/Admin/Adviser/AbnormalBehavior/Details.vue"),
          meta: {
            title: "行为偏常辅导 - " + schoolName(),
          },
        },
        /*********************************************************************************
            品德评语
        **********************************************************************************/
        {
          //列表
          path: "/Admin/Adviser/StudentComment/Index",
          component: () =>
            import("../views/Admin/Adviser/StudentComment/Index.vue"),
          meta: {
            title: "品德评语 - " + schoolName(),
          },
        },
        {
          //新增
          path: "/Admin/Adviser/StudentComment/Create",
          component: () =>
            import("../views/Admin/Adviser/StudentComment/Create.vue"),
          meta: {
            title: "品德评语 - " + schoolName(),
          },
        },
        {
          //编辑
          path: "/Admin/Adviser/StudentComment/Edit/:Id",
          component: () =>
            import("../views/Admin/Adviser/StudentComment/Create.vue"),
          meta: {
            title: "品德评语 - " + schoolName(),
          },
        },
        {
          //查看
          path: "/Admin/Adviser/StudentComment/Details/:Id",
          component: () =>
            import("../views/Admin/Adviser/StudentComment/Details.vue"),
          meta: {
            title: "品德评语 - " + schoolName(),
          },
        },
        /*********************************************************************************
            学生谈话
        **********************************************************************************/
        {
          //列表
          path: "/Admin/Adviser/IndividualEducation/Index",
          component: () =>
            import("../views/Admin/Adviser/IndividualEducation/Index.vue"),
          meta: {
            title: "学生谈话 - " + schoolName(),
          },
        },
        {
          //新增
          path: "/Admin/Adviser/IndividualEducation/Create",
          component: () =>
            import("../views/Admin/Adviser/IndividualEducation/Create.vue"),
          meta: {
            title: "学生谈话 - " + schoolName(),
          },
        },
        {
          //编辑
          path: "/Admin/Adviser/IndividualEducation/Edit/:Id",
          component: () =>
            import("../views/Admin/Adviser/IndividualEducation/Create.vue"),
          meta: {
            title: "学生谈话 - " + schoolName(),
          },
        },
        {
          //查看
          path: "/Admin/Adviser/IndividualEducation/Details/:Id",
          component: () =>
            import("../views/Admin/Adviser/IndividualEducation/Details.vue"),
          meta: {
            title: "学生谈话 - " + schoolName(),
          },
        },

        /*********************************************************************************
            成绩管理 Score
        **********************************************************************************/
        {
          //列表
          path: "/Admin/Score/Index",
          component: () => import("../views/Admin/Score/Index.vue"),
          meta: {
            title: "成绩管理 - " + schoolName(),
          },
        },
        /*********************************************************************************
            学生成绩 Score
        **********************************************************************************/
        {
          //学生成绩
          path: "/Admin/Score/Adviser",
          component: () => import("../views/Admin/Score/Adviser.vue"),
          meta: {
            title: "学生成绩 - " + schoolName(),
          },
        },
        {
          //学生成绩 查看
          path: "/Admin/Score/Detail/:id",
          component: () => import("../views/Admin/Score/Details.vue"),
          meta: {
            title: "学生成绩 - " + schoolName(),
          },
        },
        {
          //学生成绩 编辑
          path: "/Admin/Score/Edit/:id",
          component: () => import("../views/Admin/Score/Edit.vue"),
          meta: {
            title: "学生成绩 - " + schoolName(),
          },
        },
        {
          //学生成绩 汇总
          path: "/Admin/Score/Course",
          component: () => import("../views/Admin/Score/Course.vue"),
          meta: {
            title: "学生成绩 - " + schoolName(),
          },
        },
        {
          //学生成绩 录入
          path: "/Admin/Score/AdviserScoreRecord",
          component: () =>
            import("../views/Admin/Score/AdviserScoreRecord.vue"),
          meta: {
            title: "学生成绩 - " + schoolName(),
          },
        },
        /*********************************************************************************
            处分管理 StudentPunish
        **********************************************************************************/
        {
          //列表
          path: "/Admin/StudentPunish/Index",
          component: () => import("../views/Admin/StudentPunish/Index.vue"),
          meta: {
            title: "学生处分 - " + schoolName(),
          },
        },
        {
          //详情
          path: "/Admin/StudentPunish/Detail/:id",
          component: () => import("../views/Admin/StudentPunish/Details.vue"),
          meta: {
            title: "学生处分 - " + schoolName(),
          },
        },
        {
          //编辑
          path: "/Admin/StudentPunish/Edit/:id",
          component: () => import("../views/Admin/StudentPunish/Update.vue"),
          meta: {
            title: "学生处分 - " + schoolName(),
          },
        },
        {
          //新增
          path: "/Admin/StudentPunish/Create",
          component: () => import("../views/Admin/StudentPunish/Update.vue"),
          meta: {
            title: "学生处分 - " + schoolName(),
          },
        },
        /*********************************************************************************
            班主任手册 学生处分  StudentPunish
        **********************************************************************************/
        {
          //列表
          path: "/Admin/Adviser/StudentPunish/Index",
          component: () => import("../views/Admin/StudentPunish/Index.vue"),
          meta: {
            title: "学生处分 - " + schoolName(),
          },
        },
        {
          //详情
          path: "/Admin/Adviser/StudentPunish/Detail/:id",
          component: () => import("../views/Admin/StudentPunish/Details.vue"),
          meta: {
            title: "学生处分 - " + schoolName(),
          },
        },
        {
          //编辑
          path: "/Admin/Adviser/StudentPunish/Edit/:id",
          component: () => import("../views/Admin/StudentPunish/Update.vue"),
          meta: {
            title: "学生处分 - " + schoolName(),
          },
        },
        {
          //新增
          path: "/Admin/Adviser/StudentPunish/Create",
          component: () => import("../views/Admin/StudentPunish/Update.vue"),
          meta: {
            title: "学生处分 - " + schoolName(),
          },
        },
        /*********************************************************************************
            班主任手册撤销  StudentPunishRevocation
        **********************************************************************************/
        {
          //列表
          path: "/Admin/StudentPunishRevocation/Index",
          component: () =>
            import("../views/Admin/StudentPunishRevocation/Index.vue"),
          meta: {
            title: "处分撤销 - " + schoolName(),
          },
        },
        {
          // 撤销 新增
          path: "/Admin/StudentPunishRevocation/Create",
          component: () =>
            import("../views/Admin/StudentPunishRevocation/Create.vue"),
          meta: {
            titel: "处分撤销 - " + schoolName(),
          },
        },
        {
          // 撤销 查看
          path: "/Admin/StudentPunishRevocation/Detils/:id",
          component: () =>
            import("../views/Admin/StudentPunishRevocation/Detils.vue"),
          meta: {
            title: "处分撤销 - " + schoolName(),
          },
        },
        {
          // 活动 列表
          path: "/Admin/activity/index/:type",
          component: () => import("../views/Admin/Activity/Index.vue"),
          meta: {
            title: "活动 - " + schoolName(),
          },
        },
        {
          // 活动附件审核 activity_img_audit
          path: "/Admin/activity/AuditAT/:Id",
          component: () => import("../views/Admin/Activity/AuditAT.vue"),
          meta: {
            title: "活动 - " + schoolName(),
          },
        },
        {
          // 活动 列表
          path: "/Admin/activity/create/:type",
          component: () => import("../views/Admin/Activity/Update.vue"),
          meta: {
            title: "活动 - " + schoolName(),
          },
        },
        {
          // 活动 列表
          path: "/Admin/activity/edit/:type/:id",
          component: () => import("../views/Admin/Activity/Update.vue"),
          meta: {
            title: "活动 - " + schoolName(),
          },
        },
        {
          // 活动 列表
          path: "/Admin/activity/range/:type/:id",
          component: () => import("../views/Admin/Activity/Range.vue"),
          meta: {
            title: "活动 - " + schoolName(),
          },
        },
        {
          // 活动 列表
          path: "/Admin/activity/confirm/:type/:id",
          component: () => import("../views/Admin/Activity/Confirm.vue"),
          meta: {
            title: "活动 - " + schoolName(),
          },
        },
        {
          // 活动 列表
          path: "/Admin/activity/roster/:type/:id",
          component: () => import("../views/Admin/Activity/Roster.vue"),
          meta: {
            title: "活动 - " + schoolName(),
          },
        },
        {
          // 活动 列表
          path: "/Admin/Activity/Delegate/:type/:id",
          component: () => import("../views/Admin/Activity/Delegate.vue"),
          meta: {
            title: "活动 - " + schoolName(),
          },
        },

        {
          // 活动 列表
          path: "/Admin/activity/detail/:type/:id",
          component: () => import("../views/Admin/Activity/Detail.vue"),
          meta: {
            title: "活动 - " + schoolName(),
          },
        },
        {
          // 活动 列表
          path: "/Admin/activity/prize/:type/:id",
          component: () => import("../views/Admin/Activity/Prize.vue"),
          meta: {
            title: "活动 - " + schoolName(),
          },
        },
        {
          // 活动 列表
          path: "/Admin/activity/prizeCreate/:activityId",
          component: () => import("../views/Admin/Activity/PrizeUpdate.vue"),
          meta: {
            title: "活动 - " + schoolName(),
          },
        },

        {
          // 活动 列表
          path: "/Admin/activity/prizeEdit/:activityId/:id",
          component: () => import("../views/Admin/Activity/PrizeUpdate.vue"),
          meta: {
            title: "活动 - " + schoolName(),
          },
        },
        {
          // 活动 列表
          path: "/Admin/activity/prizeDetail/:activityId/:id",
          component: () => import("../views/Admin/Activity/PrizeDetail.vue"),
          meta: {
            title: "活动 - " + schoolName(),
          },
        },
        {
          // 列表
          path: "/Admin/GrowthConfig/Index",
          component: () => import("../views/Admin/GrowthConfig/Index.vue"),
          meta: {
            title: "评价纬度配置 - " + schoolName(),
          },
        },
        {
          // 详情
          path: "/Admin/GrowthConfig/Details/:Id",
          component: () => import("../views/Admin/GrowthConfig/Details.vue"),
          meta: {
            title: "综合评价参数 - " + schoolName(),
          },
        },
        {
          // 列表
          path: "/Admin/GrowthConfigClass/Index",
          component: () => import("../views/Admin/GrowthConfigClass/Index.vue"),
          meta: {
            title: "综合评价参数 - " + schoolName(),
          },
        },
        {
          // 详情
          path: "/Admin/GrowthConfigClass/Details/:Id",
          component: () =>
            import("../views/Admin/GrowthConfigClass/Details.vue"),
          meta: {
            title: "综合评价参数 - " + schoolName(),
          },
        },
        /*********************************************************************************
            日常事务 日常动态管理 自我记录 SelfReport
        **********************************************************************************/
        {
          // 自我记录 列表
          path: "/Admin/Dumurecord/StudentIndex",
          component: () => import("../views/Admin/Dumurecord/StudentIndex.vue"),
          meta: {
            title: "学生门禁记录 - " + schoolName(),
          },
        },
        {
          // 自我记录 列表
          path: "/Admin/Dumurecord/TeacherIndex",
          component: () => import("../views/Admin/Dumurecord/TeacherIndex.vue"),
          meta: {
            title: "教师门禁记录 - " + schoolName(),
          },
        },
        {
          // 自我记录 列表
          path: "/Admin/Dumurecord/TXstudentIndex",
          component: () =>
            import("../views/Admin/Dumurecord/TXstudentIndex.vue"),
          meta: {
            title: "通校生门禁 - " + schoolName(),
          },
        },
        {
          // 自我记录 列表
          path: "/Admin/SelfReport/Index",
          component: () => import("../views/Admin/SelfReport/Index.vue"),
          meta: {
            title: "上报审核 - " + schoolName(),
          },
        },
        {
          // 自我记录 详情
          path: "/Admin/SelfReport/Details/:id",
          component: () => import("../views/Admin/SelfReport/Details.vue"),
          meta: {
            title: "上报审核 - " + schoolName(),
          },
        },
        {
          // 自我记录 审核
          path: "/Admin/SelfReport/Audit/:id",
          component: () => import("../views/Admin/SelfReport/Audit.vue"),
          meta: {
            title: "上报审核 - " + schoolName(),
          },
        },
        /*********************************************************************************
            班主任手册 自我记录 SelfReport
        **********************************************************************************/
        {
          // 自我记录 列表
          path: "/Admin/Adviser/SelfReport/Index",
          component: () => import("../views/Admin/SelfReport/Index.vue"),
          meta: {
            title: "上报审核 - " + schoolName(),
          },
        },
        {
          // 自我记录 详情
          path: "/Admin/Adviser/SelfReport/Details/:id",
          component: () => import("../views/Admin/SelfReport/Details.vue"),
          meta: {
            title: "上报审核 - " + schoolName(),
          },
        },
        {
          // 自我记录 审核
          path: "/Admin/Adviser/SelfReport/Audit/:id",
          component: () => import("../views/Admin/SelfReport/Audit.vue"),
          meta: {
            title: "上报审核 - " + schoolName(),
          },
        },
        /*********************************************************************************
            日常事务 竞赛获奖 StudentPrize
        **********************************************************************************/
        {
          // 列表
          path: "/Admin/StudentPrize/Index",
          component: () => import("../views/Admin/StudentPrize/Index.vue"),
          meta: {
            title: "学生奖励 - " + schoolName(),
          },
        },
        {
          // 详情
          path: "/Admin/StudentPrize/Detail/:id",
          component: () => import("../views/Admin/StudentPrize/Details.vue"),
          meta: {
            title: "学生奖励 - " + schoolName(),
          },
        },
        {
          // 新增
          path: "/Admin/StudentPrize/Create",
          component: () => import("../views/Admin/StudentPrize/Update.vue"),
          meta: {
            title: "学生奖励 - " + schoolName(),
          },
        },
        {
          // 编辑
          path: "/Admin/StudentPrize/Edit/:id",
          component: () => import("../views/Admin/StudentPrize/Update.vue"),
          meta: {
            title: "学生奖励 - " + schoolName(),
          },
        },
        /*********************************************************************************
            班主任手册 学生奖励 StudentPrize
        **********************************************************************************/
        {
          // 列表
          path: "/Admin/Adviser/StudentPrize/Index",
          component: () => import("../views/Admin/StudentPrize/Index.vue"),
          meta: {
            title: "学生奖励 - " + schoolName(),
          },
        },
        {
          // 申请审核
          path: "/Admin/Adviser/StudentPrize/List",
          component: () => import("../views/Admin/StudentPrize/List.vue"),
          meta: {
            title: "学生奖励 - " + webTitleName() + " - " + schoolName(),
          },
        },
        {
          // 详情
          path: "/Admin/Adviser/StudentPrize/Detail/:id",
          component: () => import("../views/Admin/StudentPrize/Details.vue"),
          meta: {
            title: "学生奖励 - " + schoolName(),
          },
        },
        {
          // 新增
          path: "/Admin/Adviser/StudentPrize/Create",
          component: () => import("../views/Admin/StudentPrize/Update.vue"),
          meta: {
            title: "学生奖励 - " + schoolName(),
          },
        },
        {
          // 编辑
          path: "/Admin/Adviser/StudentPrize/Edit/:id",
          component: () => import("../views/Admin/StudentPrize/Update.vue"),
          meta: {
            title: "学生奖励 - " + schoolName(),
          },
        },
        {
          // 详情
          path: "/Admin/Adviser/StudentPrize/Audit/:Id",
          component: () => import("../views/Admin/StudentPrize/Audit.vue"),
          meta: {
            title: "学生奖励 - " + webTitleName() + " - " + schoolName(),
          },
        },

        /*********************************************************************************
             班干部管理  ClassCadreMgt
        **********************************************************************************/
        {
          // 列表
          path: "/Admin/Adviser/ClassCadreMgt/Index",
          component: () =>
            import("../views/Admin/Adviser/ClassCadreMgt/Index.vue"),
          meta: {
            title: "班干部管理 - " + schoolName(),
          },
        },
        /*********************************************************************************
		             房源管理 Dorm
		        **********************************************************************************/
        {
          // 列表
          path: "/Admin/Dorm/Index",
          component: () => import("../views/Admin/Dorm/Index.vue"),
          meta: {
            title: "房源管理 - " + schoolName(),
          },
        },
        {
          // 新增寝室楼
          path: "/Admin/Dorm/Create",
          component: () => import("../views/Admin/Dorm/Create.vue"),
          meta: {
            title: "房源管理 - " + schoolName(),
          },
        },
        {
          // 新增寝室楼
          path: "/Admin/Dorm/Edit/:id",
          component: () => import("../views/Admin/Dorm/Create.vue"),
          meta: {
            title: "房源管理 - " + schoolName(),
          },
        },
        {
          // 新增房间信息
          path: "/Admin/Dorm/Room/:id",
          component: () => import("../views/Admin/Dorm/Room.vue"),
          meta: {
            title: "房源管理 - " + schoolName(),
          },
        },
        {
          // 详情
          path: "/Admin/Dorm/Details/:id",
          component: () => import("../views/Admin/Dorm/Details.vue"),
          meta: {
            title: "房源管理 - " + schoolName(),
          },
        },
        /*********************************************************************************
             寝室记录 DormCheck
        **********************************************************************************/
        {
          // 列表
          path: "/Admin/DormCheck/Index",
          component: () => import("../views/Admin/DormCheck/Index.vue"),
          meta: {
            title: "寝室记录 - " + schoolName(),
          },
        },
        /*********************************************************************************
             寝室管理 DormManage
        **********************************************************************************/
        {
          // 列表
          path: "/Admin/DormManage/Index",
          component: () => import("../views/Admin/DormManage/Index.vue"),
          meta: {
            title: "寝室管理 - " + schoolName(),
          },
        },
        {
          // 视图
          path: "/Admin/DormManage/Building",
          component: () => import("../views/Admin/DormManage/Building.vue"),
          meta: {
            title: "寝室管理 - " + schoolName(),
          },
        },
        {
          // 视图
          path: "/Admin/DormManage/Floor/:id",
          component: () => import("../views/Admin/DormManage/Floor.vue"),
          meta: {
            title: "寝室管理 - " + schoolName(),
          },
        },
        /*********************************************************************************
            留宿停宿名单 DormSuspend
        **********************************************************************************/
        {
          // 列表
          path: "/Admin/DormStaySuspend/Index",
          component: () => import("../views/Admin/DormStaySuspend/Index.vue"),
          meta: {
            title: "留宿登记 - " + webTitleName() + " - " + schoolName(),
          },
        },
        {
          // 新增
          path: "/Admin/DormStaySuspend/Create/:type",
          component: () => import("../views/Admin/DormStaySuspend/Update.vue"),
          meta: {
            title: "留宿停宿名单 - " + webTitleName() + " - " + schoolName(),
          },
        },
        {
          // 编辑
          path: "/Admin/DormStaySuspend/Edit/:type/:id",
          component: () => import("../views/Admin/DormStaySuspend/Update.vue"),
          meta: {
            title: "留宿停宿名单 - " + webTitleName() + " - " + schoolName(),
          },
        },
        {
          // 查看
          path: "/Admin/DormStaySuspend/Details/:type/:id",
          component: () => import("../views/Admin/DormStaySuspend/Details.vue"),
          meta: {
            title: "留宿停宿名单 - " + webTitleName() + " - " + schoolName(),
          },
        },
        {
          // 新增
          path: "/Admin/DormStaySuspend/TeacherCreate/:type",
          component: () => import("../views/Admin/DormStaySuspend/Create.vue"),
          meta: {
            title: "留宿停宿名单 - " + webTitleName() + " - " + schoolName(),
          },
        },
        {
          // 编辑
          path: "/Admin/DormStaySuspend/TeacherEdit/:type/:id",
          component: () => import("../views/Admin/DormStaySuspend/Create.vue"),
          meta: {
            title: "留宿停宿名单 - " + webTitleName() + " - " + schoolName(),
          },
        },
        /*********************************************************************************
             调动日志 DormChg
        **********************************************************************************/
        {
          // 列表
          path: "/Admin/DormChg/Index",
          component: () => import("../views/Admin/DormChg/Index.vue"),
          meta: {
            title: "调动日志 - " + schoolName(),
          },
        },
        /*********************************************************************************
             综合评价参数 CoreLiteracy
        **********************************************************************************/
        {
          // 列表
          path: "/Admin/CoreLiteracy/Index",
          component: () => import("../views/Admin/CoreLiteracy/Index.vue"),
          meta: {
            title: "综合评价参数 - " + schoolName(),
          },
        },
        /*********************************************************************************
          管理 College
        **********************************************************************************/
        {
          path: "/Admin/College/Index",
          component: () => import("../views/Admin/College/Index.vue"),
          meta: {
            title: webCollegeName() + "管理 - " + schoolName(),
          },
        },
        /*********************************************************************************
            专业管理 Major
        **********************************************************************************/
        {
          path: "/Admin/Major/Index",
          component: () => import("../views/Admin/Major/Index.vue"),
          meta: {
            title: "专业管理 - " + schoolName(),
          },
        },
        /*********************************************************************************
            班级管理 Class
        **********************************************************************************/
        {
          path: "/Admin/Class/Index",
          component: () => import("../views/Admin/Class/Index.vue"),
          meta: {
            title: "班级管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Class/Create",
          component: () => import("../views/Admin/Class/Edit.vue"),
          meta: {
            title: "班级管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Class/Detail/:id",
          component: () => import("../views/Admin/Class/Detail.vue"),
          meta: {
            title: "班级管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Class/Edit/:id",
          component: () => import("../views/Admin/Class/Edit.vue"),
          meta: {
            title: "班级管理 - " + schoolName(),
          },
        },
        /*********************************************************************************
            评语短语 CommentPhrase
        **********************************************************************************/
        {
          path: "/Admin/CommentPhrase/Index",
          component: () => import("../views/Admin/CommentPhrase/Index.vue"),
          meta: {
            title: "评语短语 - " + schoolName(),
          },
        },
        /*********************************************************************************
            班级获奖 ClassPrize
        **********************************************************************************/
        {
          path: "/Admin/ClassPrize/Index",
          component: () => import("../views/Admin/ClassPrize/Index.vue"),
          meta: {
            title: "班级获奖 - " + schoolName(),
          },
        },
        {
          path: "/Admin/ClassPrize/Create",
          component: () => import("../views/Admin/ClassPrize/Create.vue"),
          meta: {
            title: "班级获奖 - " + schoolName(),
          },
        },
        {
          path: "/Admin/ClassPrize/Details/:id",
          component: () => import("../views/Admin/ClassPrize/Details.vue"),
          meta: {
            title: "班级获奖 - " + schoolName(),
          },
        },
        {
          path: "/Admin/ClassPrize/Edit/:id",
          component: () => import("../views/Admin/ClassPrize/Create.vue"),
          meta: {
            title: "班级获奖 - " + schoolName(),
          },
        },
        /*********************************************************************************
            班级获奖类型 ClassPrizeType
        **********************************************************************************/
        {
          path: "/Admin/ClassPrizeType/Index",
          component: () => import("../views/Admin/ClassPrizeType/Index.vue"),
          meta: {
            title: "班级获奖类型 - " + schoolName(),
          },
        },
        {
          path: "/Admin/ClassPrizeType/Create",
          component: () => import("../views/Admin/ClassPrizeType/Create.vue"),
          meta: {
            title: "班级获奖类型 - " + schoolName(),
          },
        },
        {
          path: "/Admin/ClassPrizeType/Details/:id",
          component: () => import("../views/Admin/ClassPrizeType/Details.vue"),
          meta: {
            title: "班级获奖类型 - " + schoolName(),
          },
        },
        {
          path: "/Admin/ClassPrizeType/Edit/:id",
          component: () => import("../views/Admin/ClassPrizeType/Create.vue"),
          meta: {
            title: "班级获奖类型 - " + schoolName(),
          },
        },
        /*********************************************************************************
            班级获奖级别 ClassPrizeLevel
        **********************************************************************************/
        {
          path: "/Admin/ClassPrizeLevel/Index",
          component: () => import("../views/Admin/ClassPrizeLevel/Index.vue"),
          meta: {
            title: "班级获奖级别 - " + schoolName(),
          },
        },
        /*********************************************************************************
           校历管理 SemesterDay
        **********************************************************************************/
        {
          path: "/Admin/SemesterDay/Index",
          component: () => import("../views/Admin/SemesterDay/Index.vue"),
          meta: {
            title: "校历管理 - " + schoolName(),
          },
        },
        /*********************************************************************************
            学年管理 Academic
        **********************************************************************************/
        {
          path: "/Admin/Academic/Index",
          component: () => import("../views/Admin/Academic/Index.vue"),
          meta: {
            title: "学年管理 - " + schoolName(),
          },
        },
        /*********************************************************************************
            学期管理 Semester
        **********************************************************************************/
        {
          path: "/Admin/Semester/Index",
          component: () => import("../views/Admin/Semester/Index.vue"),
          meta: {
            title: "学期管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Semester/Edit/:id",
          component: () => import("../views/Admin/Semester/Operation.vue"),
          meta: {
            title: "学期管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Semester/Create",
          component: () => import("../views/Admin/Semester/Operation.vue"),
          meta: {
            title: "学期管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Semester/Detail/:id",
          component: () => import("../views/Admin/Semester/Detail.vue"),
          meta: {
            title: "学期管理 - " + schoolName(),
          },
        },

        /*********************************************************************************
            课程管理 Course
        **********************************************************************************/
        {
          path: "/Admin/Course/Index",
          component: () => import("../views/Admin/Course/Index.vue"),
          meta: {
            title: "课程管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Course/Batch",
          component: () => import("../views/Admin/Course/Batch.vue"),
          meta: {
            title: "课程管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Course/Create",
          component: () => import("../views/Admin/Course/Operation.vue"),
          meta: {
            title: "课程管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Course/Edit/:id",
          component: () => import("../views/Admin/Course/Operation.vue"),
          meta: {
            title: "课程管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Course/Detail/:id",
          component: () => import("../views/Admin/Course/Detail.vue"),
          meta: {
            title: "课程管理 - " + schoolName(),
          },
        },
        /*********************************************************************************
            活动层级 ActivityLevel
        **********************************************************************************/
        {
          path: "/Admin/ActivityLevel/Index",
          component: () => import("../views/Admin/ActivityLevel/Index.vue"),
          meta: {
            title: "活动层级 - " + schoolName(),
          },
        },
        /*********************************************************************************
            活动配置 ActiveConfig
        **********************************************************************************/
        {
          path: "/Admin/ActiveConfig/Index",
          component: () => import("../views/Admin/ActiveConfig/Index.vue"),
          meta: {
            title: "活动配置 - " + schoolName(),
          },
        },

        {
          path: "/Admin/ActiveConfig/Create",
          component: () => import("../views/Admin/ActiveConfig/Update.vue"),
          meta: {
            title: "活动配置 - " + schoolName(),
          },
        },
        {
          path: "/Admin/ActiveConfig/Edit/:id",
          component: () => import("../views/Admin/ActiveConfig/Update.vue"),
          meta: {
            title: "活动配置 - " + schoolName(),
          },
        },

        /*********************************************************************************
            综合报告 LiteracyReport
        **********************************************************************************/
        {
          path: "/Admin/LiteracyReport/Details/:id",
          component: () => import("../views/Admin/LiteracyReport/Details.vue"),
          meta: {
            title: "综合报告 - " + schoolName(),
          },
        },
        /*********************************************************************************
            用户管理 User
        *********************************************************************************/
        {
          path: "/Admin/User/Index",
          component: () => import("../views/Admin/User/Index.vue"),
          meta: {
            title: "用户管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/User/Create",
          component: () => import("../views/Admin/User/Update.vue"),
          meta: {
            title: "用户管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/User/Edit/:id",
          component: () => import("../views/Admin/User/Update.vue"),
          meta: {
            title: "用户管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/User/Detail/:id",
          component: () => import("../views/Admin/User/Detail.vue"),
          meta: {
            title: "用户管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/User/Filter/:id",
          component: () => import("../views/Admin/User/Filter.vue"),
          meta: {
            title: "用户管理 - " + schoolName(),
          },
        },
        /*********************************************************************************
            角色管理 Index
        *********************************************************************************/
        {
          path: "/Admin/Role/Index",
          component: () => import("../views/Admin/Role/Index.vue"),
          meta: {
            title: "角色管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Role/Create",
          component: () => import("../views/Admin/Role/Update.vue"),
          meta: {
            title: "角色管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Role/Edit/:id",
          component: () => import("../views/Admin/Role/Update.vue"),
          meta: {
            title: "角色管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Role/Power/:id",
          component: () => import("../views/Admin/Role/Power.vue"),
          meta: {
            title: "角色管理 - " + schoolName(),
          },
        },
        {
          path: "/admin/StudentRole/Power/:id",
          component: () => import("../views/Admin/StudentRole/Power.vue"),
          meta: {
            title: "角色管理 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Role/Detail/:id",
          component: () => import("../views/Admin/Role/Detail.vue"),
          meta: {
            title: "角色管理 - " + schoolName(),
          },
        },
        /*********************************************************************************
            学生角色 Index
        *********************************************************************************/
        {
          path: "/Admin/StudentRole/Index",
          component: () => import("../views/Admin/StudentRole/Index.vue"),
          meta: {
            title: "学生角色 - " + schoolName(),
          },
        },
        {
          path: "/Admin/StudentRole/Create",
          component: () => import("../views/Admin/StudentRole/Create.vue"),
          meta: {
            title: "学生角色 - " + schoolName(),
          },
        },
        {
          path: "/Admin/StudentRole/Edit/:id",
          component: () => import("../views/Admin/StudentRole/Create.vue"),
          meta: {
            title: "学生角色 - " + schoolName(),
          },
        },
        //学生角色查看
        {
          path: "/Admin/StudentRole/Detail/:id",
          component: () => import("../views/Admin/StudentRole/Detail.vue"),
          meta: {
            title: "学生角色 - " + schoolName(),
          },
        },

        /*********************************************************************************
            操作日志 OperationLog
        *********************************************************************************/
        {
          // 教师
          path: "/Admin/OperationLog/Teacher/Index",
          component: () =>
            import("../views/Admin/OperationLog/Teacher/Index.vue"),
          meta: {
            title: "操作日志 - " + schoolName(),
          },
        },
        {
          // 教师
          path: "/Admin/OperationLog/Teacher/Details/:Id",
          component: () =>
            import("../views/Admin/OperationLog/Teacher/Details.vue"),
          meta: {
            title: "操作日志 - " + schoolName(),
          },
        },

        /*********************************************************************************
            异常日志 ExceptionLog
        *********************************************************************************/
        {
          // 教师
          path: "/Admin/ExceptionLog/Teacher/Index",
          component: () =>
            import("../views/Admin/ExceptionLog/Teacher/Index.vue"),
          meta: {
            title: "操作日志 - " + schoolName(),
          },
        },
        {
          // 教师
          path: "/Admin/ExceptionLog/Teacher/Details/:id",
          component: () =>
            import("../views/Admin/ExceptionLog/Teacher/Details.vue"),
          meta: {
            title: "操作日志 - " + schoolName(),
          },
        },
        /*********************************************************************************
            系統功能 Action
        *********************************************************************************/
        {
          path: "/Admin/Action/Index",
          component: () => import("../views/Admin/Action/Index.vue"),
          meta: {
            title: "系统功能 - " + schoolName(),
          },
        },

        {
          path: "/Admin/Action/Student",
          component: () => import("../views/Admin/Action/Student.vue"),
          meta: {
            title: "系统功能 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Action/Home",
          component: () => import("../views/Admin/Action/Home.vue"),
          meta: {
            title: "部署功能 - " + schoolName(),
          },
        },
        /********************************************************************************
        部门管理 Department
        **********************************************************************************/
        {
          path: "/Admin/Department/Index",
          component: () => import("../views/Admin/Department/Index.vue"),
          meta: {
            title: "部门管理 - " + schoolName(),
          },
        },
        /*********************************************************************************
        /*********************************************************************************
            数据字典 DataDictionary
        *********************************************************************************/
        {
          // 民族
          path: "/Admin/DataDictionary/Nation",
          component: () => import("../views/Admin/DataDictionary/Nation.vue"),
          meta: {
            title: "民族字典 - " + schoolName(),
          },
        },

        {
          // 政策面貌
          path: "/Admin/DataDictionary/Political",
          component: () =>
            import("../views/Admin/DataDictionary/Political.vue"),
          meta: {
            title: "政治面貌 - " + schoolName(),
          },
        },
        {
          // 奖励类型
          path: "/Admin/DataDictionary/Prize/Type",
          component: () =>
            import("../views/Admin/DataDictionary/Prize/Type.vue"),
          meta: {
            title: "数据字典 - " + schoolName(),
          },
        },
        {
          // 奖励级别
          path: "/Admin/DataDictionary/Prize/Level",
          component: () =>
            import("../views/Admin/DataDictionary/Prize/Level.vue"),
          meta: {
            title: "奖励级别 - " + schoolName(),
          },
        },
        {
          // 奖励类型-新增
          path: "/Admin/DataDictionary/Prize/Type/Create",
          component: () =>
            import("../views/Admin/DataDictionary/Prize/Update.vue"),
          meta: {
            title: "数据字典 - " + schoolName(),
          },
        },
        {
          // 奖励类型-编辑
          path: "/Admin/DataDictionary/Prize/Type/Edit/:id",
          component: () =>
            import("../views/Admin/DataDictionary/Prize/Update.vue"),
          meta: {
            title: "数据字典 - " + schoolName(),
          },
        },
        {
          // 奖励类型-查看
          path: "/Admin/DataDictionary/Prize/Type/Detail/:id",
          component: () =>
            import("../views/Admin/DataDictionary/Prize/Detail.vue"),
          meta: {
            title: "数据字典 - " + schoolName(),
          },
        },

        {
          // 处分类型
          path: "/Admin/DataDictionary/Punish/Type",
          component: () =>
            import("../views/Admin/DataDictionary/Punish/Type.vue"),
          meta: {
            title: "处分等级 - " + schoolName(),
          },
        },
        {
          // 处分类型-新增
          path: "/Admin/DataDictionary/Punish/Type/Create",
          component: () =>
            import("../views/Admin/DataDictionary/Punish/Update.vue"),
          meta: {
            title: "处分等级 - " + schoolName(),
          },
        },
        {
          // 处分类型-编辑
          path: "/Admin/DataDictionary/Punish/Type/Edit/:id",
          component: () =>
            import("../views/Admin/DataDictionary/Punish/Update.vue"),
          meta: {
            title: "处分等级 - " + schoolName(),
          },
        },
        {
          // 处分类型-查看
          path: "/Admin/DataDictionary/Punish/Type/Detail/:id",
          component: () =>
            import("../views/Admin/DataDictionary/Punish/Detail.vue"),
          meta: {
            title: "处分等级 - " + schoolName(),
          },
        },
        {
          // 处分原因
          path: "/Admin/DataDictionary/Punish/Reason",
          component: () =>
            import("../views/Admin/DataDictionary/Punish/Reason.vue"),
          meta: {
            title: "数据字典 - " + schoolName(),
          },
        },
        {
          // 处分原因 - 新增
          path: "/Admin/DataDictionary/Punish/Reason/Create",
          component: () =>
            import("../views/Admin/DataDictionary/Punish/Update.vue"),
          meta: {
            title: "数据字典 - " + schoolName(),
          },
        },
        {
          // 处分原因 - 编辑
          path: "/Admin/DataDictionary/Punish/Reason/Edit/:id",
          component: () =>
            import("../views/Admin/DataDictionary/Punish/Update.vue"),
          meta: {
            title: "处分原因 - " + schoolName(),
          },
        },
        {
          // 处分原因 - 查看
          path: "/Admin/DataDictionary/Punish/Reason/Detail/:id",
          component: (resolve) =>
            require([
              "@/views/Admin/DataDictionary/Punish/Detail.vue",
            ], resolve),
          meta: {
            title: "处分原因 - " + schoolName(),
          },
        },

        {
          // 扣分类型
          path: "/Admin/MoralityReason/Type",
          component: () => import("../views/Admin/MoralityReason/Type.vue"),
          meta: {
            title: "行为规范分类 - " + schoolName(),
          },
        },
        {
          // 扣分原因
          path: "/Admin/MoralityReason/Index",
          component: () => import("../views/Admin/MoralityReason/Index.vue"),
          meta: {
            title: "行为规范原因 - " + schoolName(),
          },
        },
        {
          // 扣分原因
          path: "/Admin/MoralityReason/Create/:Type",
          component: () => import("../views/Admin/MoralityReason/Reason.vue"),
          meta: {
            title: "行为规范原因 - " + schoolName(),
          },
        },
        {
          // 扣分原因
          path: "/Admin/MoralityReason/Update/:Type/:Id",
          component: () => import("../views/Admin/MoralityReason/Reason.vue"),
          meta: {
            title: "行为规范原因 - " + schoolName(),
          },
        },
        {
          // 扣分原因授权
          path: "/Admin/MoralityReason/Authorization/:Type",
          component: () =>
            import("../views/Admin/MoralityReason/Authorization.vue"),
          meta: {
            title: "行为规范原因授权 - " + schoolName(),
          },
        },
        /*********************************************************************************
            行为规范
        *********************************************************************************/
        {
          // 列表
          path: "/Admin/Morality/Index",
          component: () => import("../views/Admin/Morality/Index.vue"),
          meta: {
            title: "行为规范 - " + schoolName(),
          },
        },
        {
          // 新增
          path: "/Admin/Morality/Create/:type",
          component: () => import("../views/Admin/Morality/Update.vue"),
          meta: {
            title: "行为规范 - " + schoolName(),
          },
        },
        {
          // 编辑
          path: "/Admin/Morality/Edit/:type/:id",
          component: () => import("../views/Admin/Morality/Update.vue"),
          meta: {
            title: "行为规范 - " + schoolName(),
          },
        },
        {
          // 查看
          path: "/Admin/Morality/Detail/:type/:id",
          component: () => import("../views/Admin/Morality/Detail.vue"),
          meta: {
            title: "行为规范 - " + schoolName(),
          },
        },
        {
          // 落实
          path: "/Admin/Morality/Implement/:id",
          component: () => import("../views/Admin/Morality/Implement.vue"),
          meta: {
            title: "行为规范 - " + schoolName(),
          },
        },
        /*********************************************************************************
          行为规范
        *********************************************************************************/
        {
          path: "/Admin/Adviser/Morality/Index",
          component: () => import("../views/Admin/Adviser/Morality/Index.vue"),
          meta: {
            title: "本班综合分 - " + schoolName(),
          },
        },
        {
          path: "/Admin/Adviser/Morality/Record",
          component: () => import("../views/Admin/Adviser/Morality/Record.vue"),
          meta: {
            title: "全校综合分 - " + schoolName(),
          },
        },

        {
          // 新增
          path: "/Admin/Adviser/Morality/Create/:type",
          component: () => import("../views/Admin/Adviser/Morality/Update.vue"),
          meta: {
            title: "新增行为规范 - " + schoolName(),
          },
        },
        {
          //查看
          path: "/Admin/Adviser/Morality/Detail/:type/:id",
          component: () => import("../views/Admin/Adviser/Morality/Detail.vue"),
          meta: {
            title: "行为规范 - " + schoolName(),
          },
        },
        {
          // 班级落实
          path: "/Admin/Adviser/Morality/ClassImplement/:id",
          component: () =>
            import("../views/Admin/Adviser/Morality/ClassImplement.vue"),
          meta: {
            title: "行为规范 - " + schoolName(),
          },
        },
        {
          // 寝室落实
          path: "/Admin/Adviser/Morality/DormitoryImplement/:id",
          component: () =>
            import("../views/Admin/Adviser/Morality/DormitoryImplement.vue"),
          meta: {
            title: "行为规范 - " + schoolName(),
          },
        },
        /*********************************************************************************
          寝室扣分
        *********************************************************************************/
        {
          // 列表
          path: "/Admin/Dormitory/Index",
          component: () => import("../views/Admin/Dormitory/Index.vue"),
          meta: {
            title: "寝室扣分 - " + schoolName(),
          },
        },
        {
          // 新增
          path: "/Admin/Dormitory/Create/:type",
          component: () => import("../views/Admin/Dormitory/Update.vue"),
          meta: {
            title: "寝室扣分 - " + schoolName(),
          },
        },
        {
          // 编辑
          path: "/Admin/Dormitory/Edit/:type/:id",
          component: () => import("../views/Admin/Dormitory/Update.vue"),
          meta: {
            title: "寝室扣分 - " + schoolName(),
          },
        },
        {
          // 查看
          path: "/Admin/Dormitory/Detail/:type/:id",
          component: () => import("../views/Admin/Dormitory/Detail.vue"),
          meta: {
            title: "寝室扣分 - " + schoolName(),
          },
        },
        {
          // 落实
          path: "/Admin/Dormitory/Implement/:id",
          component: () => import("../views/Admin/Dormitory/Implement.vue"),
          meta: {
            title: "寝室扣分 - " + schoolName(),
          },
        },
        /*********************************************************************************
           班主任手册-寝室扣分
        *********************************************************************************/
        {
          // 列表
          path: "/Admin/Adviser/Dormitory/Index",
          component: () => import("../views/Admin/Dormitory/Index.vue"),
          meta: {
            title: "寝室扣分 - " + schoolName(),
          },
        },
        {
          // 查看
          path: "/Admin/Adviser/Dormitory/Detail/:type/:id",
          component: () => import("../views/Admin/Dormitory/Detail.vue"),
          meta: {
            title: "寝室扣分 - " + schoolName(),
          },
        },
        /*********************************************************************************

        *********************************************************************************/
        {
          // 活动角色
          path: "/Admin/DataDictionary/Activity/Position",
          component: () =>
            import("../views/Admin/DataDictionary/Activity/Position.vue"),
          meta: {
            title: "数据字典 - " + schoolName(),
          },
        },
        {
          // 活动角色
          path: "/Admin/DataDictionary/Activity/Type",
          component: () =>
            import("../views/Admin/DataDictionary/Activity/Type.vue"),
          meta: {
            title: "数据字典 - " + schoolName(),
          },
        },
        {
          // 组织管理
          path: "/Admin/DataDictionary/Tissue",
          component: () => import("../views/Admin/DataDictionary/Tissue.vue"),
          meta: {
            title: "组织管理 - " + schoolName(),
          },
        },
        {
          // 设备管理
          path: "/Admin/Device/Index",
          component: () => import("../views/Admin/Device/Index.vue"),
          meta: {
            title: "设备管理 - " + schoolName(),
          },
        },
        {
          // 人员组管理
          path: "/Admin/PersonnelGroup/Index",
          component: () => import("../views/Admin/PersonnelGroup/Index.vue"),
          meta: {
            title: "门禁组管理 - " + schoolName(),
          },
        },
        {
          //通校生管理
          path: "/Admin/TXstudent/Index",
          component: () => import("../views/Admin/TXstudent/Index.vue"),
          meta: {
            title: "临时通校管理 - " + schoolName(),
          },
        },
        /*********************************************************************************
            登录日志 LoginForLog
        *********************************************************************************/
        {
          // 教师登录日志
          path: "/Admin/LOGLog/Teacher/Index",
          component: () => import("../views/Admin/LOGLog/Teacher/Index.vue"),
          meta: {
            title: "登录日志 - " + schoolName(),
          },
        },
        {
          // 教师登录日志
          path: "/Admin/LOGLog/Teacher/Details/:Id",
          component: () => import("../views/Admin/LOGLog/Teacher/Details.vue"),
          meta: {
            title: "登录日志 - " + schoolName(),
          },
        },
      ],
    },
    /*
     ************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************ 学生PC端 ******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************
     */
    {
      path: "/Student/Default",
      component: () => import("../views/Student/Default.vue"),
      meta: {
        title: schoolName(),
      },
      //redirect:'/Home/Index',// 默认起始页
      children: [
        //**********> Home <*************** 首页
        {
          path: "/Student/Home/Index",
          component: () => import("../views/Student/Home/Index.vue"),
          meta: {
            title: schoolName(),
          },
        },
        /******************************************************************************************
          学生请假
        *******************************************************************************************/
        {
          path: "/Student/LeaveMGT/Index",
          component: () => import("../views/Student/LeaveMGT/Index.vue"),
          meta: {
            title: "我的请假 - " + schoolName(),
          },
        },
        {
          path: "/Student/LeaveMGT/Default/:Id",
          component: () => import("../views/Student/LeaveMGT/Default.vue"),
          meta: {
            title: "我的请假 - " + schoolName(),
          },
        },
        {
          path: "/Student/LeaveMGT/Create",
          component: () => import("../views/Student/LeaveMGT/Update.vue"),
          meta: {
            title: "我的请假 - " + schoolName(),
          },
        },
        {
          path: "/Student/LeaveMGT/Edit/:Id",
          component: () => import("../views/Student/LeaveMGT/Update.vue"),
          meta: {
            title: "我的请假 - " + schoolName(),
          },
        },
        /******************************************************************************************
          德育分
        *******************************************************************************************/
        {
          path: "/Student/MoralEducation/Index",
          component: () => import("../views/Student/MoralEducation/Index.vue"),
          meta: {
            title: "德育分 - " + schoolName(),
          },
        },
        {
          path: "/Student/MoralEducation/Create",
          component: () => import("../views/Student/MoralEducation/Update.vue"),
          meta: {
            title: "德育分 - " + schoolName(),
          },
        },
        {
          path: "/Student/MoralEducation/Edit/:Id",
          component: () => import("../views/Student/MoralEducation/Update.vue"),
          meta: {
            title: "德育分 - " + schoolName(),
          },
        },
        {
          path: "/Student/MyMoraleducation/Index",
          component: () =>
            import("../views/Student/MyMoraleducation/Index.vue"),
          meta: {
            title: " 我的德育分 - " + schoolName(),
          },
        },
        /******************************************************************************************
          我的申请
        *******************************************************************************************/
        {
          path: "/Student/Prize/List",
          component: () => import("../views/Student/Prize/List.vue"),
          meta: {
            title: "我的申请 - " + webTitleName() + " - " + schoolName(),
          },
        },
        {
          path: "/Student/Prize/Apply",
          component: () => import("../views/Student/Prize/Apply.vue"),
          meta: {
            title: "我的申请 - " + webTitleName() + " - " + schoolName(),
          },
        },
        /******************************************************************************************
          学校社团
        *******************************************************************************************/
        {
          path: "/Student/Club/ClubMGMT/Index",
          component: () => import("../views/Student/Club/ClubMGMT/Index.vue"),
          meta: {
            title: "学校社团 - " + schoolName(),
          },
        },
        {
          path: "/Student/Club/ClubMGMT/Details/:Id",
          component: () => import("../views/Student/Club/ClubMGMT/Details.vue"),
          meta: {
            title: "学校社团 - " + schoolName(),
          },
        },
        /******************************************************************************************
         我的奖学金
        *******************************************************************************************/
        {
          path: "/Student/ScholarshipMGT/Index",
          component: () => import("../views/Student/ScholarshipMGT/Index.vue"),
          meta: {
            title: " 我的奖学金 - " + schoolName(),
          },
        },
        {
          path: "/Student/ScholarshipMGT/Create",
          component: () => import("../views/Student/ScholarshipMGT/Update.vue"),
          meta: {
            title: " 我的奖学金 - " + schoolName(),
          },
        },
        {
          path: "/Student/ScholarshipMGT/Details/:Id",
          component: () =>
            import("../views/Student/ScholarshipMGT/Details.vue"),
          meta: {
            title: " 我的奖学金 - " + schoolName(),
          },
        },
        {
          path: "/Student/ScholarshipMGT/Edit/:Id",
          component: () => import("../views/Student/ScholarshipMGT/Update.vue"),
          meta: {
            title: " 我的奖学金 - " + schoolName(),
          },
        },
        /******************************************************************************************
          班主任评语
        *******************************************************************************************/
        {
          path: "/Student/Comment/Index",
          component: () => import("../views/Student/Comment/Index.vue"),
          meta: {
            title: "社团活动 - " + schoolName(),
          },
        },
        /******************************************************************************************
          社团活动
        *******************************************************************************************/
        {
          path: "/Student/Club/ClubActivities/Index",
          component: () =>
            import("../views/Student/Club/ClubActivities/Index.vue"),
          meta: {
            title: "社团活动 - " + schoolName(),
          },
        },
        {
          path: "/Student/Club/ClubActivities/Create/:clubId",
          component: () =>
            import("../views/Student/Club/ClubActivities/Update.vue"),
          meta: {
            title: "社团活动 - " + schoolName(),
          },
        },
        {
          path: "/Student/Club/ClubActivities/Edit/:clubId/:Id",
          component: () =>
            import("../views/Student/Club/ClubActivities/Update.vue"),
          meta: {
            title: "社团活动 - " + schoolName(),
          },
        },
        {
          path: "/Student/Club/ClubActivities/Details/:Id",
          component: () =>
            import("../views/Student/Club/ClubActivities/Details.vue"),
          meta: {
            title: "社团活动 - " + schoolName(),
          },
        },
        /******************************************************************************************
          奖励记录
        *******************************************************************************************/
        {
          path: "/Student/Prize/Index",
          component: () => import("../views/Student/Prize/Index.vue"),
          meta: {
            title: "奖励记录 - " + schoolName(),
          },
        },
        {
          path: "/Student/Prize/Details/:id",
          component: () => import("../views/Student/Prize/Details.vue"),
          meta: {
            title: "奖励记录 - " + schoolName(),
          },
        },
        /******************************************************************************************
          我的成绩
        *******************************************************************************************/
        {
          path: "/Student/AcademicRecord/Index",
          component: () => import("../views/Student/AcademicRecord/Index.vue"),
          meta: {
            title: "我的成绩 - " + schoolName(),
          },
        },
        {
          path: "/Student/AcademicRecord/Details/:id",
          component: () =>
            import("../views/Student/AcademicRecord/Details.vue"),
          meta: {
            title: "我的成绩 - " + schoolName(),
          },
        },
        /******************************************************************************************
          综合课堂 LiteracyCourse
        *******************************************************************************************/
        {
          path: "/Student/LiteracyCourse/Index",
          component: () => import("../views/Student/LiteracyCourse/Index.vue"),
          meta: {
            title: "综合课堂 - " + schoolName(),
          },
        },
        {
          path: "/Student/LiteracyCourse/Details/:id",
          component: () =>
            import("../views/Student/LiteracyCourse/Details.vue"),
          meta: {
            title: "综合课堂 - " + schoolName(),
          },
        },
        /******************************************************************************************
          综合评价
        *******************************************************************************************/
        {
          path: "/Student/Growth/Index",
          component: () => import("../views/Student/Growth/Index.vue"),
          meta: {
            title: "综合评价 - " + schoolName(),
          },
        },
        /******************************************************************************************
          处分记录
        *******************************************************************************************/
        {
          path: "/Student/Punish/Index",
          component: () => import("../views/Student/Punish/Index.vue"),
          meta: {
            title: "处分记录 - " + schoolName(),
          },
        },
        {
          path: "/Student/Punish/Details/:id",
          component: () => import("../views/Student/Punish/Details.vue"),
          meta: {
            title: "处分记录 - " + schoolName(),
          },
        },
        /******************************************************************************************
          活动管理
        *******************************************************************************************/
        {
          path: "/Student/LiteracyActivities/Index",
          component: () =>
            import("../views/Student/LiteracyActivities/Index.vue"),
          meta: {
            title: "活动管理 - " + schoolName(),
          },
        },
        {
          path: "/Student/LiteracyActivities/Details/:id",
          component: () =>
            import("../views/Student/LiteracyActivities/Details.vue"),
          meta: {
            title: "活动管理 - " + schoolName(),
          },
        },
        {
          path: "/Student/LiteracyActivities/Upload/:id",
          component: () =>
            import("../views/Student/LiteracyActivities/Upload.vue"),
          meta: {
            title: "活动管理 - " + schoolName(),
          },
        },
        {
          path: "/Student/LiteracyActivities/Enroll/:id",
          component: () =>
            import("../views/Student/LiteracyActivities/Enroll.vue"),
          meta: {
            title: "活动管理 - " + schoolName(),
          },
        },
        /******************************************************************************************
          行为规范
        *******************************************************************************************/
        {
          path: "/Student/BehaviorRecord/List",
          component: () => import("../views/Student/BehaviorRecord/List.vue"),
          meta: {
            title: "行为规范 - " + schoolName(),
          },
        },
        {
          path: "/Student/BehaviorRecord/Index",
          component: () => import("../views/Student/BehaviorRecord/Index.vue"),
          meta: {
            title: "行为规范 - " + schoolName(),
          },
        },
        {
          path: "/Student/BehaviorRecord/Details/:type/:id",
          component: () =>
            import("../views/Student/BehaviorRecord/Details.vue"),
          meta: {
            title: "行为规范 - " + schoolName(),
          },
        },
        {
          path: "/Student/BehaviorRecord/DetailsList/:type/:id",
          component: () =>
            import("../views/Student/BehaviorRecord/DetailsList.vue"),
          meta: {
            title: "行为规范 - " + schoolName(),
          },
        },
        {
          path: "/Student/BehaviorRecord/Create/:type",
          component: () => import("../views/Student/BehaviorRecord/Create.vue"),
          meta: {
            title: "行为规范 - " + schoolName(),
          },
        },
        {
          // 班级落实
          path: "/Student/BehaviorRecord/ClassImplement/:id",
          component: () =>
            import("../views/Student/BehaviorRecord/ClassImplement.vue"),
          meta: {
            title: "行为规范 - " + schoolName(),
          },
        },
        /******************************************************************************************
          我的行为规范
        *******************************************************************************************/
        {
          path: "/Student/MyBehaviorRecord/Index",
          component: () =>
            import("../views/Student/MyBehaviorRecord/Index.vue"),
          meta: {
            title: "我的行为规范 - " + schoolName(),
          },
        },
        {
          path: "/Student/MyBehaviorRecord/Details/:type/:id",
          component: () =>
            import("../views/Student/MyBehaviorRecord/Details.vue"),
          meta: {
            title: "我的行为规范 - " + schoolName(),
          },
        },
        /******************************************************************************************
          成长档案
        *******************************************************************************************/
        {
          path: "/Student/LiteracyReport/Details",
          component: () =>
            import("../views/Student/LiteracyReport/Details.vue"),
          meta: {
            title: "成长档案 - " + schoolName(),
          },
        },
        {
          path: "/Student/GrowthArchives/Details",
          component: () =>
            import("../views/Student/GrowthArchives/Details.vue"),
          meta: {
            title: "成长档案 - " + schoolName(),
          },
        },
        /******************************************************************************************
          我的荣誉
        *******************************************************************************************/
        {
          path: "/Student/Myself/Reward/Index",
          component: () => import("../views/Student/Myself/Reward/Index.vue"),
          meta: {
            title: "我的荣誉 - " + schoolName(),
          },
        },
        {
          path: "/Student/Myself/Reward/Details",
          component: () => import("../views/Student/Myself/Reward/Details.vue"),
          meta: {
            title: "我的荣誉 - " + schoolName(),
          },
        },
        /******************************************************************************************
          基础信息
        *******************************************************************************************/
        {
          path: "/Student/Myself/BaseInfo/Details",
          component: () =>
            import("../views/Student/Myself/BaseInfo/Details.vue"),
          meta: {
            title: "基础信息 - " + schoolName(),
          },
        },
        {
          path: "/Student/Myself/BaseInfo/Edit",
          component: () => import("../views/Student/Myself/BaseInfo/Edit.vue"),
          meta: {
            title: "基础信息 - " + schoolName(),
          },
        },
        /******************************************************************************************
          自我记录
        *******************************************************************************************/
        {
          path: "/Student/SelfReport/Index",
          component: () => import("../views/Student/SelfReport/Index.vue"),
          meta: {
            title: "上报审核 - " + schoolName(),
          },
        },
        {
          path: "/Student/SelfReport/Create",
          component: () => import("../views/Student/SelfReport/Create.vue"),
          meta: {
            title: "上报审核 - " + schoolName(),
          },
        },
        {
          path: "/Student/SelfReport/Details/:id",
          component: () => import("../views/Student/SelfReport/Details.vue"),
          meta: {
            title: "基础信息 - " + schoolName(),
          },
        },
        {
          path: "/Student/SelfReport/Edit/:id",
          component: () => import("../views/Student/SelfReport/Create.vue"),
          meta: {
            title: "基础信息 - " + schoolName(),
          },
        },
      ],
    },
  ],
});
